import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedModule } from '@apps/landing/src/app/shared/shared.module';
import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';
import { ViewportScroller } from '@angular/common';
import { categories, contacts, socials } from '@apps/landing/src/app/core/layout/components/footer/utils/constants';

@Component({
  selector: 'app-footer',
  imports: [RouterModule, SharedModule],
  standalone: true,
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  private readonly router = inject(Router);
  private readonly viewportScroller = inject(ViewportScroller);

  protected readonly currentYear = new Date().getFullYear();
  protected readonly employeePortalUrl = signal<string>('https://portal.sapec.md');
  protected readonly PAGE_ROUTES = PAGE_ROUTES;

  protected readonly contacts = signal<{ [key: string]: string }[]>(contacts);
  protected readonly socials = signal<{ [key: string]: string }[]>(socials);
  protected readonly categories = signal<{ title: string; items: { [key: string]: string }[] }[]>(categories);

  protected redirectToFAQ() {
    this.router.navigate([PAGE_ROUTES.SERVICES]).then(() => {
      setTimeout(() => {
        this.viewportScroller.scrollToAnchor('faq');
      }, 100);
    });
  }
}
